<template>
<m-pageframe
    title="{organization_label}: Custom Keywords"
>
<v-container
    v-if="settings != null"
>

    <v-list-item
        v-for="(item, index) in settings"
        :key="index"
        style="margin-bottom: 15px;"
    >
        <v-list-item-avatar
        > 
            <v-icon size="35">mdi-forum</v-icon>
        </v-list-item-avatar>

        <v-list-item-content
        >
            <v-list-item-title
                :class="{'disabled' : !item.enabled}"
            >
                <div style="font-family: monospace; font-weight: 700; font-size: 18px">{{item.keyword}}</div>

                
            </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
            <v-menu 
                bottom 
                offset-y  
            >

            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>

            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                    :disabled="!$rc.$state.isOrganizationAdmin()"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                 <v-list-item
                    v-on:click="onClickReporting(item)"
                 >
                    <v-list-item-title>Reporting...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickCopy(item)"
                    :disabled="!$rc.$state.isOrganizationAdmin()"
                >
                    <v-list-item-title>Copy...</v-list-item-title>
                </v-list-item>    

                <v-divider/>

                <v-list-item
                    v-on:click="onClickDelete(item)"
                    :disabled="!$rc.$state.isOrganizationAdmin()"
                >
                    <v-list-item-title>Delete...</v-list-item-title>
                </v-list-item> 
            </v-list>

            </v-menu> 
          
        </v-list-item-action>
    </v-list-item>

    <div
        style="text-align: right; margin-top: 25px;"
    >
        <v-btn
            v-on:click="onClickCreateKeyword"
            style="margin-right: 15px;"
            :disabled="!this.$rc.$state.isOrganizationAdmin()"
        >
            New Keyword...
        </v-btn>

        <v-btn
            v-on:click="onClickReporting(null)"
        >
            Reporting...
        </v-btn>

    </div>

    <p
        style="font-size: 12px; margin-top: 7px; text-align: right;"
    >
        * &mdash; Want to edit your CTIA keyword responses? Go <a v-on:click="linkToCTIAKeywordSettings">here</a>.
    </p>
    
    <m-keyword-edit-dialog
        :label="keyword_dialog_label"
        ref="create-keyword-dialog"
        :action_label="keyword_dialog_action"
        :organization_id="$route.params.organization_id"
        v-on:ok="keyword_after_action"
    />

    

</v-container>
</m-pageframe>
</template>

<script>
export default {

    data() {
        return {
            organization_label: null,
            settings: null,

            keyword_dialog_label: 'Create New Keyword',
            keyword_dialog_action: 'Create',
            keyword_after_action: () => {},
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        

        update() {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET: /keyword-auto-response/settings/:organization_id',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.organization_label = data.organization_label;
                    this.settings = data.settings;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickEdit(item) {
            this.$router.push({
                'name': 'edit-keyword-auto-response',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                    'keyword' : item.keyword,
                }
            });
        },

        onClickReporting(item) {

            if ( item != null )
            {
                this.$router.push({
                    'name': 'reporting-keyword-auto-response-w-initial-keyword',
                    'params' : {
                        'organization_id' : this.$route.params.organization_id,
                        'keyword' : item.keyword,
                    }
                });
            }
            else
            {
                this.$router.push({
                    'name': 'reporting-keyword-auto-response',
                    'params' : {
                        'organization_id' : this.$route.params.organization_id
                    }
                });
            }
        },

        onClickCopy(item)
        {
            this.keyword_dialog_label = 'Copy '+item.keyword;
            this.keyword_dialog_action = 'Copy';

            this.keyword_after_action = (keyword) => {
                
                this.$rc.showSpinner();
                
                this.$rc.rest(
                    'COPY: /keyword-auto-response/settings',
                
                    {
                        'organization_id' : this.$route.params.organization_id,
                        'from' : item.keyword,
                        'to' : keyword
                    },
                
                    (data) => {
                        this.$rc.hideSpinner();
                        this.update();
                    },
                
                    () => {
                        this.$rc.hideSpinner();
                        this.$rc.alert('Error','Unable to complete API call');
                    },
                );

            };

            this.$refs['create-keyword-dialog'].showDialog();
        },

        onClickDelete(item)
        {
            this.$rc.confirm(
                'Delete '+item.keyword,
                'Delete '+item.keyword+"?",
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Delete', 'value' : 'confirm' },
                ],
                (response) => {
                    if ( response != 'confirm' ) return;
                    
                    this.$rc.showSpinner();
                    
                    this.$rc.rest(
                        'DELETE: /keyword-auto-response/settings',
                    
                        {
                            'organization_id' : this.$route.params.organization_id,
                            'keyword' : item.keyword,
                        },
                    
                        (data) => {
                            this.$rc.hideSpinner();

                            this.update();
                        },
                    
                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to complete API call');
                        },
                    );
                },
            );
        },

       onClickCreateKeyword() {
            this.keyword_dialog_label = 'Create Keyword';
            this.keyword_dialog_action = 'Create';

            this.keyword_after_action = (keyword) => {
                
                this.$rc.showSpinner();
                
                this.$rc.rest(
                    'PUT: /keyword-auto-response/settings',
                
                    {
                        'organization_id' : this.$route.params.organization_id,
                        'keyword' : keyword,
                        'enabled' : false,
                        'enabled_opt_in': false,
                        'opt_in_specimen_patterns': ['Reply YES to receive messages from {organization-label} with info, promotions and offers. We may use automation to send these texts. Consent is not a condition of purchase. Texts and calls may be recorded. Msg frequency varies. Msg and/or data rates may apply.'],
                        'opt_in_specimen_grants_conversational_consent': true,
                        'opt_in_specimen_grants_informational_consent': true,
                        'opt_in_specimen_grants_promotional_consent': true,
                        'opt_in_responses': ['YES'],
                        'enabled_add_to_list': false,
                        'add_to_list_id': null,
                        'enabled_auto_response': true,
                        'auto_response_patterns' : ['Thank you!'],
                        'opt_in_blob_ids': [],
                        'auto_response_blob_ids': [],
                    },

                
                    (data) => {
                        this.$rc.hideSpinner();
                        
                        this.$router.push({
                            'name': 'edit-keyword-auto-response',
                            'params' : {
                                'organization_id' : this.$route.params.organization_id,
                                'keyword' : keyword,
                            }
                        });
                    },
                
                    () => {
                        this.$rc.hideSpinner();
                        this.$rc.alert('Error','Unable to complete API call');
                    },
                );

            };

            this.$refs['create-keyword-dialog'].showDialog();
        },

        linkToCTIAKeywordSettings()
        {
            let route = {
                'name': 'settings-organization-ctia-keyword-auto-responses',
                'params' : {
                        'employee_id' : this.$rc.$state.employee_id,
                        'organization_id' : this.$rc.$state.organization_id,
                    },
            };

            this.$rc.navigationClick(this.$router, route, {});
        }
    },

}
</script>

<style lang="scss" scoped>
.disabled {
    color: rgba(0,0,0,0.4)
}
</style>